module.exports = __webpack_public_path__ + "static/videobg-263ce49c607b9003ecb0b9292492881f.jpeg";